import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              关于韩国漫画网的常见疑问，这里都有解答
            </p>
          </div>

          <div className="max-w-[800px] mx-auto space-y-3">
            {faqItems.map((item, i) => (
              <details
                key={i}
                className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
                open={i === 0}
              >
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-8">
                    {item.q}
                  </h3>
                  <span className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 group-open:rotate-180 transition-transform duration-200 text-sm"></i>
                  </span>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}